import { FormControl, TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
const CommonInputField = ({
  sx,
  ref,
  focused,
  variant,
  defaultValue,
  inputProps,
  type,
  inputRef,
  name,
  label,
  error,
  isError,
  control,
  dontCapitalize,
  color,
  shrink,
  disabled,
  onFocusCapture,
  onBlurCapture,
}) => {
  const [haveValue, setHaveValue] = React.useState(false);
  console.log("current value:", haveValue);
  return (
    <FormControl
      fullWidth
      size="small"
      // disabled={disabled ? true : false}
      sx={sx}
    >
      <Controller
        render={({ field }) => {
          setHaveValue(
            field?.value !== undefined &&
              field?.value !== "" &&
              field?.value !== null
          );
          return (
            <TextField
              className=" bg-white"
              inputRef={inputRef}
              onFocusCapture={onFocusCapture}
              onBlurCapture={onBlurCapture}
              ref={ref ? ref : null}
              autoComplete="off"
              inputProps={
                dontCapitalize
                  ? inputProps
                  : (inputProps,
                    {
                      style: {
                        textTransform: "capitalize",
                        fontSize: "12px",
                        height: "8px",
                      },
                    })
              }
              sx={{
                "& .MuiFormLabel-root": {
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "2px",

                  // apply only when NO value and NOT focused
                  marginTop: !haveValue ? "-5px" : "",

                  // remove when focused
                  "&.Mui-focused": {
                    marginTop: "2px",
                  },
                },
              }}
              autoFocus={focused ? true : false}
              onWheel={(e) => {
                if (type == "number") {
                  e.target.blur();
                }
              }}
              type={type}
              error={!!error?.message || isError}
              color={color}
              variant={variant}
              label={label}
              placeholder={label}
              name={name}
              fullWidth
              {...field}
              size="small"
              shrink={false}
              disabled={disabled === true ? true : false}
            />
          );
        }}
        name={name}
        control={control}
        defaultValue={defaultValue}
      />
      {/* <FormHelperText style={{ color: "#d32f2f" }}>
        {error?.message}
      </FormHelperText> */}
    </FormControl>
  );
};

export default CommonInputField;